<template>
  <SubTitle :TitleName="'店舗特典'" />
  <v-row class="pa-5 w-75 ma-auto" justify="center">
    <v-col
      v-for="card in items"
      :key="card"
      cols="12"
      sm="6"
      align-self="stretch"
    >
      <v-card class="mx-auto pa-6" max-width="500" variant="tonal">
        <template v-slot:title>
          <span class="font-weight-black">{{ card.shop }}</span>
        </template>
        <v-img :src="getImageHero(card.imageUrl)"
          ><template v-slot:placeholder>
            <div class="d-flex align-center justify-center fill-height">
              <v-progress-circular
                color="grey-lighten-4"
                indeterminate
              ></v-progress-circular>
            </div> </template
        ></v-img>
        <v-card-text class="bg-surface-light pt-4">
          {{ card.content }}
        </v-card-text>
        <v-card-actions class="flex-column justify-center">
          <v-btn
            variant="outlined"
            class="mx-auto text-capitalize my-2"
            align="center"
            color="primary"
            :href="card.linkURL1"
            target="_blank"
            rel="noopener noreferrer"
            block
            height="72"
          >
            <div class="card-text">ご予約はこちら</div>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
  import SubTitle from "./SubTitle.vue";
  export default {
    components: {
      SubTitle,
    },
    methods: {
      getImageHero(imagePath) {
        if (!imagePath) {
          return require("@/assets/store_nowprinting.png"); // デフォルト画像を src/assets に配置
        }

        try {
          return require(`@/assets/${imagePath}`); // src/assets 配下の画像を取得
        } catch (e) {
          console.error("画像の取得に失敗しました:", e);
          return require("@/assets/store_nowprinting.png");
        }
      },
    },

    data: () => ({
      items: [
        {
          shop: "Amazon様",
          imageUrl: "store_amazon.png",
          linkURL1: "https://amzn.asia/d/axBt1xH", //限定
          content: "PC & スマホ オリジナル壁紙",
        },
        {
          shop: "ゲームショップ1983様",
          imageUrl: "store1983.png",
          linkURL1:
            "https://shop.1983.jp/shop/shop.cgi?order=&class=all&keyword=%92j%8Eq%8DZ%82%C5%82%A0%82%C1%82%BD%95%7C%82%A2%98b&FF=0&price_sort=&pic_only=&mode=p_wide&id=40786&superkey=1", //限定
          content:
            "男子校であった怖い話カレンダー(2025年 12ヶ月分)+Switch互換ソフトケース",
        },
        {
          shop: "ステラワース様",
          imageUrl: "store_stella.png",
          linkURL1:
            "https://www.stellaworth.co.jp/shop/item.php?item_id=pM94iF3iQF4",
          content: "L判ブロマイド7枚セット",
        },
        {
          shop: "ステラワース様",
          imageUrl: "store_stellaset.png",
          linkURL1:
            "https://www.stellaworth.co.jp/shop/item.php?item_id=BLADoxerAKe",
          content:
            "★ステラセット　L判ブロマイド7枚セット+A4クリアファイル+57mm缶バッジ10個セット",
        },
      ],
    }),
  };
</script>
